import { CORPORATE_CLIENTS } from "../../Types/corpotateClients";

export const setCoprateClients = (payload) => ({
    type : CORPORATE_CLIENTS,
    payload 
  })
   